import { render, staticRenderFns } from "./ChatBotComponent.vue?vue&type=template&id=0a9e9d5c&scoped=true"
import script from "./ChatBotComponent.vue?vue&type=script&lang=js"
export * from "./ChatBotComponent.vue?vue&type=script&lang=js"
import style0 from "./ChatBotComponent.vue?vue&type=style&index=0&id=0a9e9d5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e9d5c",
  null
  
)

export default component.exports